namespace TabAurous.ECommerce {
    export namespace ReturnOrderItemsSelectService {
        export const baseUrl = 'ECommerce/ReturnOrderItemsSelect';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<ECommOrderItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ECommerce/ReturnOrderItemsSelect/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>ReturnOrderItemsSelectService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
